import FieldProto_ManagementPreview from "./render/management-preview"
import FieldProto_ManagementForm from "./render/management-form"
import FieldProto_Picker from "./render/picker"
import FieldProto_FormElementView from "./render/form-element-view"
import FieldProto_View from "./render/view"
import FieldProto_ViewSmall from "./render/view-small"
import FieldProto_InlineEditable from "./render/inline-editable"
import FieldProto_GListView from "./render/glist/glist-view"
import FieldProto_GListEditable from "./render/glist/glist-editable"
import FieldProto_GListGroup from "./render/glist/glist-group"
import FieldProto_QuickFilterView from "./render/quick-filter-view"
import FieldProto_FormElement from "./render/form-element"
import FormManager from "../../gd-form/common/form-manager"
import FieldProto_GlistGroupModern from "./components/glist-group/modern"
import FieldProto_GlistGroupStandard from "./components/glist-group/standard"
import FieldProto_AutomationTriggerForm from "./render/automation/automation-trigger-form"
import FieldProto_AutomationConditionForm from "./render/automation/automation-condition-form"
import FieldProto_AutomationActionForm from "./render/automation/automation-action-form"
import ImportFromCSVModule from "../../gd-modules/import-from-csv/import-from-csv-module"
import FieldProto_ConditionForm from "./render/condition/condition-form"
import {FieldType} from "../field-type"
import {IConditionType} from "../../model2/conditions/condition-types"
import {entityPrefix, EntityType} from "../../gd/const/item"
import {SortDirection} from "../../data-structures/sort"
import Field_GraphTickLabelView from "./render/graph-tick-label"
import FieldProto_GraphTooltipView from "./render/graph-tooltip"
import {ColorPalette, DefaultPaletteColorNumber, ItemColorCoding} from "../color-coding/color-coding"
import FieldProto_ViewReference from "./render/view-reference"
import FieldProto_CSVImportPreview from "./render/csv-import-preview"
import AggregateProto from "../../fields/aggregate/aggregate-proto"
import FieldProto_TableCell from "./render/table/table-cell"
import {FieldAccess} from "../const"
import FieldProto_InlineEditableSmall from "./render/inline-editable-small"
import FieldProto_Editable from "./render/editable"
import FieldProto_ViewProperty from "./render/view-property"
import {
    FieldClasses,
    FieldComponents,
    FieldFilterType,
    FieldGroupAllPossibleValues_Params,
    FieldParams,
    FieldRenderComponents
} from "./types"
import ModelEntity from "../../model2/model-entity"
import FieldProto_GoalListView from "./render/goal-list/goal-list-view"
import FieldProto_GoalListEditable from "./render/goal-list/goal-list-editable"
import FieldProto_ManagementFormCFV1 from "./render/management-form-cfv1"
import {CustomFieldAccess} from "../../model2/custom-field/@const"
import ItemModel from "../../model2/item/item-model"
import FieldProto_ControlView from "./render/control-view"
import PopoverPosition from "../../gd-components/gd-popover/popover-position"
import FieldProto_TListGroupHeader1 from "./render/list/list-group-header-1"
import FieldProto_TListGroupHeader2 from "./render/list/list-group-header-2"
import GroupBy from "../../gd/manager/group-by/group-by-model"
import Filter from "../../manager/filters/manager/filter"
import {FilterItemModel} from "../../manager/filters/manager/@types"
import ItemModelV2 from "../../model2/item2/item-model"
import ProjectSession from "../../model2/project/project-session"

// const debug = "FieldProto"
const debug = false

export default class FieldProto {

    public _version             : number = 3

    public isNewField           : boolean =  false      // set to true during creation of a field...

    // specifies entity type for field i.e. task project etc.
    // enables systemFieldName = ENTITY.FIELDID
    // and usage in collections where we have multiple entities together ?
    public entityType           : EntityType | null

    // Save anything here and use anywhere :)
    // added by Vic on 29 apr 2024 to support date field pastdue option
    public fieldParams          : FieldParams   = {}

    private _dataFields?        : string[]

    public menuMoreParams!      : any

    // Type Related
    public type                 : FieldType         // type of the field - see fields constants
    public typeInteger          : number = 0        // used for organization custom fields (tasks projects)
    public typeLabel            : string
    public typeGroup            : string | null
    public typeDescription      : string            // used in add field etc

    // default value for this type of field in list - should be overwritten
    protected FIELD_DEFAULT_WIDTH : number     = 399
    protected DEFAULT_FIELD_ACCESS : number    = CustomFieldAccess.EVERYONE

    public fieldId              : fieldId
    public icon                 : string | null = null      // field icon class
    public placeholder?         : string        // default placeholder for selector, inputs forms etc.
    public placeholderIcon?     : any           // currently is used only for project selector
    public colorPalette         : ColorPalette   = ColorPalette.CORE    // ??? color pallete associated with this field

    public popoverPosition?     : PopoverPosition  // Experimental. For fields that use popover

    public components           : FieldComponents       = {} // here we store componenets
    public classes              : FieldClasses           = {} // here we store different classes we can re-use
    public renderComponents     : FieldRenderComponents

    public filterType?          : FieldFilterType | null     // type of filter associated with this field - deprecated
    public isFilterAvailable    : boolean           =  false    // this is for new FilterV3/v4 (!!!) new way of working with filters

    public variableName         : string            // used as placeholder in FORMULAS(!) & automations like description email tempalte etc, also see patchToFixOldVariableNames

    public label                : string            // Field label / Field name
    public description          : string            // use description to specify what this field is for (hint) also used in request forms

    public _defaultWidth        : number | null // was boolean go figure why
    public isRequired           : boolean
    public isDerived            : boolean
    public isDisabled           : boolean
    public fieldAccess          : CustomFieldAccess | null     // specify who can access this field i.e. all users or managers only
    public isCustom             : boolean   // true if custom field
    public isSystem             : boolean   // true if system field

    // Called once the field has been edited through the dropdown's "Edit options" of a generic
    // (non session) custom field - that modal saves nothing itself, so whoever owns the field's
    // config sets this to persist it. See FieldDropdown_PopoverMenuMore.
    public onOptionsEdited?     : (field: FieldProto)=> void

    public formType             : string
    public formInitValue        : any

    public isCountable              : boolean   = false         // if true - we can count this field value - i.e. estimate hours, custom field number etc - used in charts and calculations
    public isSearchable             : boolean   = false         // if true we can search by this field what kinds of search ?
    public isColorCodingAvailable   : boolean   = false         // if true we can change color coding by this field
    public isSortByAvailable        : boolean   = true          // if true we can sort by this field

    public isGroupByAvailable           : boolean   = false     // if true we can group by this field
    public isGroupByAllOptionsAvailable : boolean   = false     // if true grouping will show all possible groups, even empty ones
    public groupByDefaultSortDirection  : SortDirection = SortDirection.DESC
    public groupByNoValueLabel          : string    = 'Not selected'
    public canManuallySetValue          : boolean   = true      // if true we can add task with this field's value set, otherwise new task can't have this field value manually set on creation (i.e. createdDate, lastUpdatedDate etc.)
    // public aggregateType        : any       = null        // not in use

    public modifierOptions?             : Option[]              // additional options to specify some field modifier like date interval (for dates) or time unit (for estimate)
    public modifierOptionParamName?     : string                // additional option modified name (i.e. 'interval' for date grouping)

    // CONDITIONS
    public conditionTypes           : IConditionType[] = []     // which conditions can be used with this field - is it for what ??? I think NOT for automation - most likely dashbaord is example like dynamic oncdtions
    public conditionFullWidth       : boolean = false          // render the condition tile stacked (field on its own line, form full-width below) - for wide composite forms

    // Other field specific
    // canResetValue
    public clearButton?             : boolean       // IF true inline / form has clear (reset) button
    public noDefaultPaddingMargin?  : boolean

    // dropdown only
    public options?                 : any[] | null          // dropdown options
    public noValueOption            : boolean       = false
    public noValueOptionIcon?       : string
    public noValueOptionLabel       : string        = 'No value'   // label used when no value set
    public noOptionsLabel           : string        = 'No options'
    public hasOptionWithNullValue   : boolean       = false

    // Number based fields
    public decimalPlaces?           : number    = 0
    public symbolId?                : string    // currency symbol
    public positiveOnly?            : boolean   = false
    public integersOnly?            : boolean   = false

    public trimValue                : boolean = true    // used in inlineEditable on auto submit...

    // dates only
    public minDate?                 : Moment    // min selectable date
    public maxDate?                 : Moment    // max selectable date

    public maxParents?              : number    // Dlya project full path poka chto

    // checkbox only
    public size?                    : 13 | 16   // checkbox size - yavno tak sebe idea eto tut hranit'
    public renderType?              : string    // checkbox render type: square or circle

    // multiselect checkbox only
    public lockedValues?            : ID[]

    // stepper
    public minValue?                : any
    public maxValue?                : any

    public renderGListView?         : func  // used to redefine it

    public filterValuesFiller?      : func  // this is new for v5

    public hasCalculatedValues      : boolean = false   // we should use table calculated ??? est' chto otobrazat' ???

    // pohodu net takih polei sort po vsemtu mozno
    // public isSortable               : boolean   = true  // set to False in field constructor to disable sorting

    constructor(config:any) {
        if (!config['fieldId']) console.error("Field constructor: no fieldId in config=", config);

        this.entityType     = _.get(config, 'entityType', null)

        this._dataFields    = _.get(config, 'dataFields', undefined)

        // We use clone deep because later on we might redefine fieldParams and we don't want
        // to modify original config
        // though be carefull with original config containing funcitons - not sure how it works with cloneDeep
        if (config.fieldParams) {
            this.fieldParams = _.cloneDeep(config.fieldParams)
        }

        this.typeLabel      = "Error #998272"
        this.type           = config['type'];
        this.typeGroup      = "No group set"    // used in management and add / edit field // used in add group + icon for field
        this.typeDescription= "No description"

        this.fieldId        = config['fieldId']

        this.icon           = config.icon || null

        this.variableName   = '{NOT-SPECIFIED}'

        this.label          = _.get(config, 'label', this.fieldId) // a zachem label = ID po default ... ochen' stranno
        this.description    = _.get(config, 'description', '')

        // this is private - because constructor runs first... so we use getter
        this._defaultWidth   = _.get(config, 'defaultWidth', false);   // used in GLIST

        this.isRequired     = _.get(config, 'isRequired', false);   // is required when add/edit record
        this.isDerived      = _.get(config, 'isDerived', false);    // is derived and should be skipped in new form (or any edit)
        this.isDisabled     = _.get(config, 'isDisabled', false);   // to show disabled state (grayish design) inlineedit=read

        // Access is field general access - right now only all / managers
        this.fieldAccess   = _.get(config, 'fieldAccess', this.DEFAULT_FIELD_ACCESS);

        // system/custom
        this.isCustom       = _.get(config, 'isCustom', false)
        this.isSystem       = !this.isCustom;

        this.noDefaultPaddingMargin  = _.get(config, 'noDefaultPaddingMargin', false) // property to remove default paddings and margins from field view (like p-t-7 m-t-5)

        /** Special properties **/
        // core/gd-form/common/form-manager
        this.formType       = 'input';
        this.formInitValue  = null;

        this.classes        = {}

        this.components     = {
            glistGroupModern        : FieldProto_GlistGroupModern,
            glistGroupStandard      : FieldProto_GlistGroupStandard
        }

        this.renderComponents = {
            view                    : FieldProto_View,
            viewSmall               : FieldProto_ViewSmall,
            viewReference           : FieldProto_ViewReference,
            viewProperty            : FieldProto_ViewProperty,

            inlineEditable          : FieldProto_InlineEditable,
            inlineEditableSmall     : FieldProto_InlineEditableSmall,

            editable                : FieldProto_Editable,

            picker                  : FieldProto_Picker,

            formElement             : FieldProto_FormElement,
            formElementView         : FieldProto_FormElementView,

            managementPreview       : FieldProto_ManagementPreview,
            managementForm          : FieldProto_ManagementForm,
            managementFormCFV1      : FieldProto_ManagementFormCFV1,

            quickFilterView         : FieldProto_QuickFilterView,       // this is not really filter - but special view used in list sidebar "menu" filter

            csvImportPreview        : FieldProto_CSVImportPreview,

            glistView               : FieldProto_GListView,
            glistEditable           : FieldProto_GListEditable,
            glistGroup              : FieldProto_GListGroup,

            goalListView            : FieldProto_GoalListView,
            goalListEditable        : FieldProto_GoalListEditable,

            tlistView               : null,
            tlistEditable           : null,

            tlistGroupHeader1       : FieldProto_TListGroupHeader1,
            tlistGroupHeader2       : FieldProto_TListGroupHeader2,

            tableCell               : FieldProto_TableCell,
            tableCellCalculated     : FieldProto_TableCell,

            automationTriggerForm   : FieldProto_AutomationTriggerForm,
            automationConditionForm : FieldProto_AutomationConditionForm,
            automationActionForm    : FieldProto_AutomationActionForm,

            conditionForm           : FieldProto_ConditionForm,
            filterForm              : FieldProto_ConditionForm,

            graphTickLabelView      : Field_GraphTickLabelView,
            graphTooltipView        : FieldProto_GraphTooltipView,

            controlView             : FieldProto_ControlView,

            viewGroup               : FieldProto_ViewSmall,
        }

        // this.render = new FieldRender2(this)
    }

    // DATA

    get dataFields() :string[] {
        if (this._dataFields) return this._dataFields

        // if not specified - just fieldId
        return [this.fieldId]
    }


    // ACCESS RELATED

    // Get access from a model
    access(model?:any) : FieldAccess | false | 'read' | 'write' {
        if (this.isDisabled) return FieldAccess.READ
        return FieldAccess.WRITE;
    }

    // Should be used to tell if we cn edit (isEditable) model in fiels i.e. table view Added by Vic Ap 2024
    canEdit(model:ModelEntity):boolean {
        // return true - original

        // Experimental - idea check access
        // @ts-ignore
        return model.acl ? model.acl.canChangeCustomFields : true
    }

    get canResetValue():boolean {
        return !!this.clearButton
    }

    // END ACCESS

    /*** CALCULATED & AGGREGATED ***/

    // VALUE functions

    // returns the raw value of this field from the given model, without applying any normalization or conversion
    getValue(model: any) {
        return _.get(model, this.fieldId, null)
    }

    // used to get value from model - can be redefined in specific cases like ProjectSystemType...
    getViewValue(model:any) {
        return this.getValue(model)
    }

    // used to get value from itemModel for grouping
    // (is required for multitask projects, e.g. FieldTaskParent)
    groupItemValue(itemModel: ItemModelV2, groupBy: GroupBy): any {
        return _.get(itemModel.item, this.fieldId, null)
    }

    // check if model has value - used in table cell to show reset btn - sometimes it null sometimes 0 etc.
    hasValue(model:any, optionValue?:any):boolean {

        // optionValue - used in multiselect

        return !!this.getViewValue(model)
    }

    // end VALUE functions



    // need it to know not only fieldId but also entity type on the server
    get systemFieldId():string {
        return entityPrefix(this.entityType)+'.'+this.fieldId
    }

    /*** CSV ***/

    // is used to get value from model for export to CSV - can be redefined in specific cases
    normalizeToCSVValue(model:any): any {
        return _.get(model, this.fieldId, '')
    }

    // is used to convert value for import from CSV - can be redefined in specific cases
    normalizeFromCSVValue(value: string, module: ImportFromCSVModule): any {
        return value ? value.trim() : null
    }



    public getGraphColor(model:any|null, params: any):string {

        if (!model) return '#FF0000'

        let color = gd.skin.colors.chartColors.defaultColor
        if (!_.isNil(params?.index) && !_.isNil(params?.length) && params?.length > 1) {
            color = gd.skin.colors.getProjectColorPaletteHEX(params.index)
        }

        debug && console.log(debug, 'getGraphColor', color, model, params)

        return color
    }

    // Format value to display value
    getDisplayValue(value:any) {
        return value
    }

    // Use it to normalize value when user selects
    // At the moment used in number to set min/max value
    // should be used in import too
    normalizeValue(value:any) {
        return value
    }

    // DROPDOWN METHODS
    getOptions(model?: ModelEntity):any {
        return this.options;
    }

    // This is method to get options for inline edit / form /etc
    // used for users at the moment, for example when we view FieldProjectOwner field options = all company users
    // but when we edit current model should redefine users with project users only
    // it's called in ProjectUser field and by default we do nothing
    getOptionsForEdit(model:any):any[] {
        return this.getOptions()
    }

    // This method is needed for automations to simplify getting options in dropdowns
    getAutomationOptions():any[] {
        return []
    }

    /** COLOR CODING **/
    getColorCoding(model: any): ItemColorCoding {
        if (this.isCustom) {
            return {
                colorNumber     : DefaultPaletteColorNumber.CORE,
                corePalette     : ColorPalette.CORE
            }
        } else {
            return {
                colorNumber     : DefaultPaletteColorNumber.SYSTEM,
                corePalette     : ColorPalette.SYSTEM
            }
        }
    }

    /*** MISC ***/

    get defaultWidth():number {
        return this._defaultWidth || this.FIELD_DEFAULT_WIDTH;
    }

    /*** VALIDATION FUNCTIONS ***/

    isValueValid(value:any) {return true}

    // formManager field validator
    validator(value:any, formManager:FormManager):boolean|string {
        return this.isValueValid(value)
    }

    /*** DATA FUNCTIONS ***/

    // normalize value for group by
    groupValue(value:any, groupBy?:GroupBy):any {
        console.error("#field-error-101 fieldType="+this.type+ " groupValue not implmented")
    }

    // normalize value for groups sorting
    groupSortValue(value:any, groupBy?:GroupBy):any {
        return this.groupValue(value, groupBy)
    }

    // retrieve group label for certain value
    groupLabel(value:any, groupBy?:GroupBy):string {
        return value
    }

    // retrieves all possible groups item models for specified itemsModels and project
    groupAllPossibleValues(params: FieldGroupAllPossibleValues_Params): any[] {
        const allValuesSet: Set<any> = new Set<any>()
        // allValuesSet.add(null)

        _.map(params.items, (itemModel: ItemModelV2) => {
            if (itemModel.isTask) {
                const value = this.groupItemValue(itemModel, params.groupBy)
                allValuesSet.add(value)
            }
        })

        return _.orderBy([...allValuesSet],
            [
                // null/undefined values are sorted first/last depending on direction
                (value: any) => {
                    return _.isNil(value) ? 0 : 1
                },
                // actual group value using field sort function
                (value: any) => {
                    return this.groupSortValue(value, params.groupBy)
                },
            ],
            [
                params.groupBy.sortDirection,
                params.groupBy.sortDirection
            ],
        )
    }

    // normalize value for sorting
    sortValue(value:any, model?:any) {
        console.error("NOT IMPLEMENTED #field-error-103 fieldId=", this.fieldId)
    }

    // normalize value for search
    searchValue(value:any, model:any) { console.error("NOT IMPLEMENTED #field-error-104") }

    // used in dropdowns
    public _getOption(value:any, model?:ModelEntity):any {}

    // used in automation for custom fields
    automationGetValuesForDescription(value:any) {
        // const options = this.options ? this.options : this.getOptions ? this.field.getOptions() : null
        const options = this.getOptions()
        if (options) {
            const values = Array.isArray(value) ? value : [value]
            return _(values)
                .map(value=>_.find(options, o=>o.value === value))
                .compact()
                .map(o=>o.label)
                .value()
        } else {
            return [value]
        }
    }

    get previewModel() {
        const model : any = {}
        model[this.fieldId] = "No preview value set"
        return model
    }

    get requiredBackendFields() {
        return [this.fieldId]
    }

    /**
     * Default condition type for this field (fallback to first from conditionTypes if not set)
     */
    get defaultConditionType(): IConditionType | undefined {
        return this.conditionTypes?.[0] || undefined
    }

    // *** FILTER ***

    // Old filters v1-v3
    public getFilterOptions(optionsSet?:Set<any>):Option[] {
        // this function is supposed to be used when we filter dropdown dynamic fields
        // e.g. with project filter we have a set of all projects in collection and need convert it
        // to Option[]
        throw Error("#kdjs-293 Not implemented")
    }

    filterFunc(filter: Filter, model: any):boolean {
        console.warn("#9d837363 not implemented field=", this)
        return true
    }

    // Returns false if the item model does not pass the filter check and should be hidden.
    filterItemModel(filter: Filter, itemModel: FilterItemModel): boolean {
        return  filter.field?.entityType !== itemModel.type   // check entity type
                || this.filterFunc(filter, itemModel.item)    // check filter conditions
    }

    // *** IMPORT EXPORT ***

    toJson() {

        const result:any = {
            fieldId         : this.fieldId,
            type            : this.type,
        }

        if (this.label !== this.fieldId) result['label'] = this.label;
        if (this.description) result['description'] = this.description;

        if (this.defaultWidth!==this.FIELD_DEFAULT_WIDTH) result['defaultWidth'] = this.defaultWidth;

        if (this.isRequired) result['isRequired'] = true;

        if (this.fieldAccess !== this.DEFAULT_FIELD_ACCESS) result['fieldAccess'] = this.fieldAccess;

        return result;
    }

    get version():number {
        return this._version
    }

    getAggregateValue_V2(model:any): any {
        const res = _.get(model, this.fieldId, null)
        debug && console.log(debug, 'getAggregateValue_V2', this.fieldId, res, model)
        return res
    }

    // BELOW IS INTERFACE FOR FIELD1 SUPPORT

    // Aggregate froim field 1
    getAggregateValue(model:any) {
        debug && console.log(debug, 'getAggregateValue', this.fieldId, this.getViewValue(model), model)
        return this.getViewValue(model)
    }
    getAggregateClass():any {return AggregateProto}
    getAggregateOptions():any {return []}
    getDefaultAggregateFunction():any {return null}
    get AggregateComponent():any {
        console.error(this.constructor.name, 'AggregateComponent not implemented!');
        return false
    }

    getGroupObject(value: any) {
        console.error("#9987jk - FieldProto: getGroupObject is not implemented!")

        return {
            id      : null,
            value   : null,
            label   : '',
            name    : 'Not selected',
        }
    }

    // group function
    listItemGroupFunction():any {
        return (listItem:any) => this.groupValue(this.getViewValue(listItem.item))
    }

    // sort function
    listItemSortFunctions(sort: SortDirection):any {
        // console.error("#djdh3937", this.constructor.name, 'listItemSortFunctions not implemented!');
        return {
            functions: [
                (listItem: ItemModel) => {
                    const calculated = (listItem as unknown as ItemModelV2).calculated
                    if (calculated) {
                        const dataByAggregateFunc = calculated.dataByAggregateFunction[this.fieldId]
                        if (dataByAggregateFunc) {
                            const firstKey = _.keys(dataByAggregateFunc)[0]
                            const calculatedValues = (dataByAggregateFunc as any)[firstKey]
                            if (!_.isNil(calculatedValues?.total?.value)) {
                                return this.sortValue(calculatedValues.total.value, listItem.item)
                            }
                        }
                    }
                    return this.sortValue(listItem.item[this.fieldId as keyof {}], listItem.item)
                }
            ],
            directions: [sort]
        }
    }

    // CSV from field 1
    getCsvValue(item:any, listItem?:any) {
        // item = model
        // listItem = obolochka vokrug item in table views etc
        return this.normalizeToCSVValue(item)
    }


    // be carefu7ll seems like from v1 fields but at the mom it breaks table edit column -<> edtit field
    isFormulaCompatible():boolean {
        return false
    }

    // getValueForFormula
    getFormulaValue(model:any) {
        return _.get(model, this.fieldId, 0)
    }

    // used to determine date based fields...
    get isDateField():boolean {
        return false
    }

    get FormAddComponent() {
        return this.renderComponents.managementForm
    }

    get systemTypeName() {
        return this.typeLabel
    }


    countValue(model:any):number {
        console.error("#9d834hd Not implemented - this field does not support countValue fieldId=", this.fieldId, "type=", this.type)
        return 1    // just in case
    }

}
